import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {setConfig} from '../actions'
import locale from '../locale'
import CommentList from '../components/CommentList'


class NewsPage extends Component {
  componentWillMount() {
    this.props.dispatch(setConfig('title',locale.R.news))
  }
  render() {
    return (
      <div>
        <CommentList list={this.props.list}/>
      </div>
    )
  }
}

function mapStateToProps(state,props) {
  let { comments } = state
  comments = comments['0'] || {}
  let list = Object.keys(comments)
                   .map(id=>comments[id])
                   .sort((a,b)=>(b.timestamp-a.timestamp))
  return {
    list
  }
}

export default connect(mapStateToProps)(NewsPage)



/** WEBPACK FOOTER **
 ** ./src/app/containers/NewsPage.js
 **/